__webpack_require__.p = "/SpeedTypingGame/";